var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpecial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.8 14.9",
    style: {
      enableBackground: "new 0 0 14.8 14.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BA84F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,0H8.5C8.2,0,8.1,0,8,0.2L0.2,7.9C0,8,0,8.2,0,8.3s0,0.3,0.2,0.5L6,14.7v0.1h0.1c0.1,0,0.2,0.1,0.3,0.1 c0.2,0,0.3-0.1,0.5-0.3l7.7-7.8c0.2-0.2,0.2-0.4,0.2-0.5V0.6C14.8,0.3,14.5,0,14.2,0z M13.5,1.3V6l-7.1,7.1L1.5,8.3l7.1-7 C8.6,1.3,13.5,1.3,13.5,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,5.1c0.8,0,1.6-0.7,1.6-1.5S12.2,2,11.3,2c-0.8,0-1.6,0.6-1.6,1.5S10.4,5.1,11.3,5.1z M11,3.5 c0-0.3,0.2-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.4s-0.1,0.4-0.4,0.4S11,3.8,11,3.5z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpecial);
export default __webpack_public_path__ + "static/media/icon-special.b1feac43c595e4f9710a56501b3c4b92.svg";
export { ForwardRef as ReactComponent };